import * as React from 'react';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
import { Redirect } from 'react-router';
import { Pagination } from '@mui/material';
import axios from '../../helpers/axios';
import { isUatEnvironment } from '../../helpers/uatMasking';
import { Grid, Card, CardContent, CardHeader, IconButton, Button, MenuItem, Typography, FormControl, TextField, CardActions, Modal, Box, Select, InputLabel, Divider, Backdrop, CircularProgress, Stack, Chip, ButtonGroup, Autocomplete } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withTranslation, WithTranslation } from 'react-i18next';
import OperationsHeader from './OperationsHeader';
import { DataGrid, GridCellParams, GridRowParams } from '@mui/x-data-grid';
import { EditOutlined, CloseOutlined } from '@mui/icons-material';
import debounce from 'lodash.debounce';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { formatDate } from '../../helpers/custom';
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';


const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '65%',
  p: 4,
};
function CustomPagination({ count, page, onChange }: { count: number, page: number, onChange: (event: React.ChangeEvent<unknown>, value: number) => void }) {
  return (
      <Pagination
          count={count}
          page={page}
          onChange={onChange}
          color="primary"
          shape="rounded"
          variant="outlined"
          showFirstButton
          showLastButton
      
      
      
      />
  );
} 

export interface IProps {
  user: {
    id: number;
    name: string;
    email: string;
    role: string;
    is_active: boolean;
    selectedHierarchies: any[];
    selectedHierarchyIds: any[];
  };
}

export interface IState {
  pageSize: number;
  anchorEl: any;
  bag_inventory_data: any[];
  showDeleteBagModal: boolean;
  filter: any;
  status: any;
  listOfBarcode: any;
  showLoader: any;
  rowCount: any;
  bagsGiven: any;
  bagsGotBack: any;
  payment_status: any;
  slots: any[];
  pickupSlot: any;
  duration: any;
  showCustomDateFilter: boolean;
  pickup_date: any;
  routes: any;
  communities: any;
  currentPage: any;
}

class CommunityPickups extends React.Component<RouteComponentProps<any> & IProps & WithTranslation, IState> {
  constructor(props: RouteComponentProps & IProps & WithTranslation) {
    super(props);
    this.state = {
      pageSize: 10,
      currentPage: 0,
      anchorEl: null,
      bag_inventory_data: [],
      showDeleteBagModal: false,
      filter: '',
      status: 'all',
      listOfBarcode: '',
      showLoader: false,
      rowCount: 0,
      bagsGiven: 0,
      bagsGotBack: 0,
      payment_status: 'all',
      slots: [],
      pickupSlot: '',
      duration: 'today',
      showCustomDateFilter: false,
      pickup_date: '',
      routes: [],
      communities: [],
    }
  }
  public componentDidMount(): void {
    this.fetchListofCommunityPickups();
    this.fetchSlots();
    this.fetchRoutes();
  }

  public fetchListofCommunityPickups(page: any = 0, limit: number = this.state.pageSize) {
    this.setState({ showLoader: true ,currentPage:page});
    let date = new Date();

    let data: any = {
      'hierarchies': this.props.user.selectedHierarchyIds,
      'filter': this.state.filter,
      'limit': limit,
      'page': page + 1,
      'communities': this.state.communities.map((el: any) => el.id),
      'payment_status': this.state.payment_status,
      'pickup_date': '',
      'pickup_type': 'community',
    //   'pickup_status': this.state.status,
      'slot_id': this.state.pickupSlot,
    }
    if(this.state.status != 'all'){
        data['pickup_status'] = this.state.status
    }
    if(this.state.duration == 'today'){
        data['pickup_date'] = formatDate(new Date(), 'Y-m-d')
    } else if(this.state.duration == 'yesterday'){
        data['pickup_date'] = formatDate(new Date().setDate(date.getDate() - 1), 'Y-m-d')
    } else if(this.state.duration == 'all'){
        data['pickup_date'] = '';
    } else if(this.state.duration == 'custom' && this.state.pickup_date){
        data['pickup_date'] = formatDate(this.state.pickup_date, 'Y-m-d');
    }
    
    // if(this.state.status == 'reached_warehouse'){
    //   data['reached_warehouse'] = "reached_warehouse";
    // }else if(this.state.status == 'with_users'){
    //   data['user'] = "with_users";
    // }
    axios.post('filterPickups', data, { headers: { 'Content-Type': 'application/json' } }).then((response: any) => {
      if (response.data.success) {
        this.setState({ showLoader: false });

        let data = response.data.data.data;
        let pickupData = data.map((el: any) => {
            let customClassNames: any = [];
            if(el.pickup_status == 'complete' && el.payment_status == 'complete'){
                customClassNames.push('pickupCompleteClass');
            } else {
                customClassNames.push('pickupPendingClass');
            }
            return(
                {
                    ...el,
                    'customClassNames' : customClassNames.join(" ")
                }
            )
        })
        console.log("data", pickupData);
        this.setState({ bag_inventory_data: pickupData, bagsGiven: response.data.msg[0], bagsGotBack: response.data.msg[1] });
        this.setState({ rowCount: response.data.data.total });

      } else {
        this.setState({ showLoader: false });
        toast.error(response.data.msg, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored"
        });
        let errors = response.data.errors;
        for (var error in errors) {
          toast.error(errors[error][0], {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored"
          });
        }
      }
    })

  }

  handleSearch = debounce((page: number = 0, limit: number = this.state.pageSize) => {
    this.fetchListofCommunityPickups(page, limit);
  }, 800);

  public fetchRoutes() {
    axios.get(`allCommunitiesLite`, {
        params: { hierarchies: this.props.user.selectedHierarchyIds },
    }).then((response) => {
        let data: any = response.data.data;
        // let routes: any = [];
        // data.map((route: any) => {
        //     routes[route.id] = {
        //         id: route.id,
        //         route: route.name,
        //         type: route.type,
                // hierarchy_id: route.hierarchy_id,
                // hierarchy_name: route.hierarchy_name,
        //     };
        // });
        this.setState({ routes: data });
    });
}

  public fetchSlots() {
    if (this.props.user.selectedHierarchyIds.length) {
        // this.setState({ showLoader: true });
        let options = { "hierarchies": this.props.user.selectedHierarchyIds }
        axios.get(`allSlotLite`, { params: options }).then((response: any) => {
            // this.setState({ showLoader: false });
            let slots: any = response.data.data;
            this.setState({ slots: slots });
        });
    }
}

  public render() {
    if (!localStorage.getItem('token')) {
      return (
        <Redirect to="/login" />
      );
    }
    const { t } = this.props;
    const open = Boolean(this.state.anchorEl);
    const renderMaskedCell = (value: React.ReactNode) => (
      <Box
        component="span"
        sx={isUatEnvironment ? {
          filter: 'blur(4px)',
          opacity: 0.5,
          userSelect: 'none',
        } : undefined}
      >
        {value}
      </Box>
    );

    const columns = [
      {
        headerName: "ID",
        field: "id",
        width: 100,
        renderCell: (params: GridCellParams) => (
          <Link to={`/operations/batch-pickups/group-pickups/pickup-details/${params.id}`} style={{ textDecoration: 'none' }}>{params.row.id}<OpenInNewOutlinedIcon sx={{ verticalAlign: "middle" }} /></Link>
      )
      },
      {
        headerName: "Date (Slot)",
        field: "pickup_date",
        width: 200,
        //   this.props.history.push('/neighbourhood/customers/' + params.row.user_id)
        renderCell: (params: GridCellParams) => (
          <Link to={`/operations/batch-pickups/group-pickups/pickup-details/${params.id}`} style={{ textDecoration: 'none', color: 'black' }}>
            {params.row.pickup_date} ({params.row.pickup_slot})
          </Link>
        ),
      },
      {
        headerName: "Name",
        field: "cust_name",
        width: 200,
        renderCell: (params: GridCellParams) => (
          <Link to={`/neighbourhood/customers/${params.row.user_id}`} style={{ textDecoration: 'none', color: 'black' }}>
            {renderMaskedCell(params.row.cust_name)}
          </Link>
        ),
      },
      {
        headerName: "Mobile",
        field: "cust_phone",
        width: 150,
        renderCell: (params: GridCellParams) => (
          <Link to={`/operations/batch-pickups/group-pickups/pickup-details/${params.id}`} style={{ textDecoration: 'none' }}>{renderMaskedCell(params.row.cust_phone)}</Link>
      )
        
      },
      {
        headerName: "Type",
        field: "type",
        width: 110,
      },
      {
        headerName: "H.No.",
        field: "cust_hno",
        width: 70,
        renderCell: (params: GridCellParams) => (
          <Link to={`/operations/batch-pickups/group-pickups/pickup-details/${params.id}`} style={{ textDecoration: 'none' }}>{renderMaskedCell(params.row.cust_hno)}</Link>
      )
      },
      {
        headerName: "Community",
        field: "community",
        width: 170,
        renderCell: (params: GridCellParams) => (
          <Link to={`/neighbourhood/customers/${params.row.user_id}`} style={{ textDecoration: 'none', color: 'black' }}>
            {renderMaskedCell(params.row.community.name)}
          </Link>
        ),
      },
      {
        headerName: "Agent",
        field: "agent_name",
        width: 110,
        renderCell: (params: GridCellParams) => (
          <Link to={`/operations/batch-pickups/group-pickups/pickup-details/${params.id}`} style={{ textDecoration: 'none' }}>{renderMaskedCell(params.row.agent_name)}</Link>
      )
      },
      {
        headerName: "Status",
        field: "pickup_status",
        width: 110,
      },
      {
        headerName: "Payment",
        field: "payment_status",
        width: 110,
        renderCell: (params: GridCellParams) => (
            <Typography>{renderMaskedCell(params.row.payment_status == '' ? 'N/A' : params.row.payment_status)}</Typography>
        )
      },
      {
        headerName: "Total kgs",
        field: "weight",
        width: 110,
        renderCell: (params: GridCellParams) => (
            <Typography>{params.row.weight ? params.row.weight.total : 0}</Typography>
        )
      },
      {
        headerName: "Comment",
        field: "comment",
        width: 370,
        renderCell: (params: GridCellParams) => (
            <Typography>{params.row?.last_comment?.comment}</Typography>
        )
      },
    ];


    return (
      <div>
        <Backdrop
          sx={{ zIndex: (theme: any) => theme.zIndex.drawer + 1000 }}
          open={this.state.showLoader}
          // onClick={() => this.setState({ showLoader: false })}
        >
          <CircularProgress className='customLoader' />
        </Backdrop>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <OperationsHeader />
        <Grid container spacing={2}>
          <Grid item md={12} xs={12} className="mt-3">
            <Card style={{height: 650}}>
              <CardHeader
                title={
                  <Typography variant='h5' className='MuiCardHeader-title' sx={{ lineHeight: "40px" }}>{t("Community Pickups")}</Typography>
                }
                className="text-left"
                action={
                    // <Grid container spacing={2}>
                    //     <Grid item md={3} xs={12}>
                    <ButtonGroup variant="contained" className="diversionButtonGroup float-right" aria-label="Material Flow of Diverted Waste button group">
                        <Button className={(this.state.duration == 'yesterday' ? "active" : "")} onClick={() => this.setState({ duration: 'yesterday'}, () => this.fetchListofCommunityPickups())}>{t("Y'day")}</Button>
                        <Button className={(this.state.duration == 'today' ? "active" : "")} onClick={() => this.setState({ duration: 'today'}, () => this.fetchListofCommunityPickups())}>{t("Today")}</Button>
                        <Button className={(this.state.duration == 'all' ? "active" : "")} onClick={() => this.setState({ duration: 'all'}, () => this.fetchListofCommunityPickups())}>{t("All")}</Button>
                        <Button className={(this.state.duration == 'custom') ? "active" : ""} onClick={() => { this.setState({ duration: 'custom', showCustomDateFilter: true }); }}>{t("Custom")}</Button>
                    </ButtonGroup>
                            
                    //     </Grid>
                    // </Grid>
                }
              />
              <CardContent>
                <Grid container spacing={2} className='mb-2'>
                  <Grid item md={2} xs={2}>
                    <FormControl fullWidth={true} size="small">
                      <TextField
                        id="filter-input"
                        label={t("Search")}
                        name="filter"
                        value={this.state.filter}
                        onChange={(e: any) => this.setState({ "filter": e.target.value }, () => this.handleSearch())}
                        fullWidth={true}
                        size="small"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item md={2} xs={2}>
                    <FormControl fullWidth={true} size="small" className="text-left">
                      <InputLabel id="route-type-label">{t("Status")}</InputLabel>
                      <Select
                        labelId="route-type-label"
                        value={this.state.status}
                        onChange={(e: any) => this.setState({ "status": e.target.value }, () => this.fetchListofCommunityPickups())}
                        displayEmpty
                        label={t("Status")}
                      >
                        <MenuItem key={'all'} value={'all'}>{t("All")}</MenuItem>
                        {/* <MenuItem key={'reached_warehouse'} value={'reached_warehouse'}>{t("Reached Warehouse")}</MenuItem>
                        <MenuItem key={'with_users'} value={'with_users'}>{t("With Users")}</MenuItem> */}
                        <MenuItem key={'pending'} value={'pending'}>{t("Pending")}</MenuItem>
                        <MenuItem key={'complete'} value={'complete'}>{t("Completed")}</MenuItem>
                        <MenuItem key={'rescheduled'} value={'rescheduled'}>{t("Rescheduled")}</MenuItem>
                        <MenuItem key={'cancelled'} value={'cancelled'}>{t("Cancelled")}</MenuItem>
                        <MenuItem key={'collected'} value={'collected'}>{t("Collected")}</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item md={2} xs={2}>
                    <FormControl fullWidth={true} size="small" className="text-left">
                      <InputLabel id="route-type-label">{t("Payment")}</InputLabel>
                      <Select
                        labelId="route-type-label"
                        value={this.state.payment_status}
                        onChange={(e: any) => this.setState({ "payment_status": e.target.value }, () => this.fetchListofCommunityPickups())}
                        displayEmpty
                        label={t("Payment")}
                      >
                        <MenuItem key={'all'} value={'all'}>{t("All")}</MenuItem>
                        <MenuItem key={'pending'} value={'pending'}>{t("Pending")}</MenuItem>
                        <MenuItem key={'complete'} value={'complete'}>{t("Completed")}</MenuItem>
                        <MenuItem key={'partial'} value={'partial'}>{t("Partially Paid")}</MenuItem>
                        <MenuItem key={'hq'} value={'hq'}>{t("Head Quarters")}</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item md={2} xs={2}>
                    <FormControl fullWidth={true} size="small">
                        <InputLabel id="type-label">{t("Slot")}</InputLabel>
                        <Select
                            labelId="type-label"
                            value={this.state.pickupSlot}
                            onChange={(e) => this.setState({ pickupSlot: e.target.value }, () => this.fetchListofCommunityPickups())}
                            displayEmpty
                            label={t("Slot")}
                            fullWidth={true}
                        >
                            <MenuItem key={20} value={20}>{t("Morning")}</MenuItem>
                            <MenuItem key={21} value={21}>{t("Afternoon")}</MenuItem>
                            <MenuItem key={22} value={22}>{t("Evening")}</MenuItem>
                            {/* <MenuItem key={23} value={23}>Testing</MenuItem> */}

                        </Select>
                    </FormControl>
                </Grid>
                <Grid item md={4} xs={4}>
                    <Autocomplete
                        multiple
                        id={"Community"}
                        options={this.state.routes}
                        size="small"
                        // sx={{float: 'right', width: '300px'}}
                        fullWidth
                        isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                        getOptionLabel={(option: any) => option.name}
                        value={this.state.communities}
                        onChange={(e: any, value: any) => this.setState({communities: value}, () => this.fetchListofCommunityPickups())}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={t("Community")}
                                placeholder={t("Select Communities")}
                            />
                        )}
                    />
                </Grid>
                  {/* <Grid item md={6} xs={12} className='text-right'>
                    <Button variant="contained" size="medium" sx={{ outline: 'none !important' }} onClick={() => this.setState({ showDeleteBagModal: true })}>
                      Delete Bags Permanently
                    </Button>
                  </Grid> */}
                </Grid>
                <DataGrid
                  aria-label={t("List of Barcoded Bags")}
                  columns={columns}
                  rows={this.state.bag_inventory_data}
                  rowCount={this.state.rowCount}
                  pageSize={this.state.pageSize}
                  onPageChange={(page) => this.fetchListofCommunityPickups(page)}
                  onPageSizeChange={(newPageSize) => { this.setState({ pageSize: newPageSize }); this.fetchListofCommunityPickups(0, newPageSize); }}
                  rowsPerPageOptions={[10, 20, 50, 100]}
                  // autoHeight={true}
                  style={{ height: 500 }}
                  pagination
                  components={{
                    MoreActionsIcon: EditOutlined,
                    Pagination: () => (
                      <CustomPagination
                          count={Math.ceil(this.state.rowCount / this.state.pageSize)}
                          page={this.state.currentPage+1}
                          onChange={(event, page) => this.fetchListofCommunityPickups(page-1)}
                        
                      />
                  )
                  }}
                  // onRowClick={(params: GridRowParams) => {
                  //   this.props.history.push('/neighbourhood/customers/' + params.row.user_id)
                  // }}
                  paginationMode="server"
                  // className="clickableList"
                  getRowClassName={(params: any) =>
                    params.row.customClassNames
                  }
                />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        <Modal
            open={this.state.showCustomDateFilter}
            onClose={() => this.setState({ showCustomDateFilter: false })}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <Card>
                    <CardHeader
                        title={t("Select Custom Date")}
                        className="text-left"
                        action={
                            <IconButton color="primary" className='customIconButton' aria-label="upload picture" component="span" onClick={() => this.setState({ showCustomDateFilter: false })}>
                                <CloseOutlined />
                            </IconButton>
                        }
                    />
                    <CardContent>
                        <Divider className="mb-3" />
                        <Grid container spacing={2}>
                            <Grid item md={6} xs={12}>
                                <FormControl fullWidth={true}>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            inputFormat="yyyy-MM-dd"
                                            views={['year', 'month', 'day']}
                                            mask="____-__-__"
                                            renderInput={(props) => <TextField {...props} />}
                                            label={t("Pickup Date") + " *"}
                                            value={this.state.pickup_date}
                                            onChange={(newValue: any) => {
                                                this.setState({ pickup_date: newValue });
                                            }}
                                        />
                                    </LocalizationProvider>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Divider className='mt-3' />
                    </CardContent>
                    <CardActions className='float-right'>
                        <Button size='small' className='customCloseButton' onClick={() => this.setState({ showCustomDateFilter: false })}>{t("Close")}</Button>
                        <Button size='small' variant='contained' sx={{ outline: 'none !important' }} disabled={!this.state.pickup_date} onClick={() => {this.fetchListofCommunityPickups(); this.setState({showCustomDateFilter: false})}}>{t("Submit")}</Button>
                    </CardActions>
                </Card>
            </Box>
        </Modal>
      </div>
    )
  }
}

export default withRouter(withTranslation()(CommunityPickups))
